import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {Icon, Menu, t} from "core/idtek-component";
import {Link} from "react-router-dom";
import AppStore from "../../store";
import {onChangeOpenKeys} from "../actions/menuAction";
import AppUtil from "../../utils/AppUtil";
import SideMenu from "./SideMenu";
import {changeBreadcrumb, changeSideMenu} from "../actions/action";
import _ from "lodash";

class AppMenu extends PureComponent {
    componentWillReceiveProps(nextProps) {
        if (nextProps.selectKeys[0] !== this.props.selectKeys[0]) {
            const nextRoute = SideMenu.findRoute(nextProps.selectKeys[0], nextProps.allMenuItems) || {};
            const breadcrumbs = [];
            this.pushBreadcrumb(nextRoute, breadcrumbs);
            AppStore.dispatch(changeBreadcrumb(breadcrumbs));
        }
    }

    componentDidMount() {
        const { allMenuItems } = this.props
        const route = SideMenu.findRoute(this.props.selectKeys[0], allMenuItems) || {};
        const inDomainItems = SideMenu.getSideMenus(this.props.selectKeys[0], allMenuItems);
        const parentRoute = AppUtil.DataUtil.find(allMenuItems, (x) => x.id === route.parentId);
        if (parentRoute) {
            AppStore.dispatch(onChangeOpenKeys([parentRoute.route]));
        }
        if (inDomainItems) {
            // computed domain
            let tree = SideMenu.buildMenuTree(inDomainItems);
            tree = SideMenu.customSort(tree);

            AppStore.dispatch(changeSideMenu(tree));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectKeys[0] !== this.props.selectKeys[0] || prevProps.allMenuItems !== this.props.allMenuItems) {
            const { allMenuItems } = this.props;
            const nextRoute = SideMenu.findRoute(this.props.selectKeys[0], allMenuItems) || {};
            const prevRoute = SideMenu.findRoute(prevProps.selectKeys[0], allMenuItems) || {};
            // computed openKeys
            // computed sideMenus

            if (prevRoute.route !== nextRoute.route) {

                const inDomainItems = SideMenu.getSideMenus(this.props.selectKeys[0], allMenuItems);
                const parentRoute = AppUtil.DataUtil.find(allMenuItems, (x) => x.id === nextRoute.parentId);
                if (parentRoute) {
                    AppStore.dispatch(onChangeOpenKeys([parentRoute.route]));
                }
                if (inDomainItems) {
                    // computed domain
                    let tree = SideMenu.buildMenuTree(inDomainItems);
                    tree = SideMenu.customSort(tree);
                    // tree && tree.map(item => {
                    //     if (item.children && !_.isEmpty(item.children)) {
                    //         const findItemLicense = _.find(item.children, x => x.isLicense)
                    //         item.isLicense = !!findItemLicense
                    //     }
                    // })
                    // tree = _.orderBy(tree, ['isLicense'], ['desc'])
                    AppStore.dispatch(changeSideMenu(tree));
                }
            }
        }
    }

    pushBreadcrumb = (nextRoute, breadcrumbs) => {
        if (_.get(nextRoute, "parent") && _.get(nextRoute, "parent.level") > 1) {
            this.pushBreadcrumb(nextRoute.parent, breadcrumbs);
        }
        breadcrumbs.push(nextRoute);
    };

    isCrossDomain(route) {
        return route && route.indexOf("http") !== -1;
    }

    generateRoute(route) {
        if (this.isCrossDomain(route)) return AppUtil.GLOBAL_API_PATH + "/redirect-loginv2?redirectUrl=" + route;
        return route;
    }

    generateMenuCode(name) {
        if (name) return name.split(' ').join('').toUpperCase();
    }

    renderMenu(menus, start) {
        return _.map(menus, (menu, index) => {
            if (menu.active) {
                if (!menu.children) {
                    const { icon, name, route, background, isLicense } = menu;
                    let elementLock = <></>
                    if (!isLicense) {
                        elementLock = <div style={{ position: 'absolute', top: "18px", right: "10px" }}>
                            <Icon type="lock"
                                style={{ fontSize: 14, color: "#ccc" }} />
                        </div>
                    }
                    return (
                        route && (
                            <Menu.Item key={route}>
                                {route.startsWith("http") ? (
                                    <a
                                        href={this.generateRoute(route)}
                                        target="_bank"
                                        className="route-side-menu"
                                        onClick={() => {
                                            AppStore.history.replace({ state: true });
                                        }}
                                    >
                                        {icon && (
                                            <div className="side-menu-icon-wrap">
                                                <i
                                                    className={`${icon} ${background ? "side-menu-icon" : ""}`}
                                                    style={{
                                                        background,
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <span
                                            className="side-menu-text">
                                            {`${menu.lvl > 1 ? (start > 0 ? start + "." + (index + 1) : index + 1) + " " : ""}${t("AppMenu-" + this.generateMenuCode(name))}`}
                                        </span>
                                        {menu.bagdeNumber > 0 &&
                                            (menu.bagdeNumber > 100 ? <span className="side-menu-bagde">{"99+"}</span> :
                                                <span className="side-menu-bagde">{menu.bagdeNumber}</span>)}
                                        {elementLock}

                                    </a>
                                ) : (
                                    <Link
                                        to={route}
                                        className="route-side-menu"
                                        onClick={() => {
                                            AppStore.history.replace({ state: true });
                                        }}
                                    >
                                        <div className="side-menu-icon-wrap">
                                            <i
                                                className={`${icon} ${background ? "side-menu-icon" : ""}`}
                                                style={{
                                                    background,
                                                }}
                                            />
                                        </div>
                                        <span
                                            className="side-menu-text">{`${menu.lvl > 1 ? (start > 0 ? start + "." + (index + 1) : index + 1) + " " : ""}${t("AppMenu-" + this.generateMenuCode(name))}`}</span>
                                        {menu.bagdeNumber > 0 &&
                                            (menu.bagdeNumber > 100 ? <span className="side-menu-bagde">{"99+"}</span> :
                                                <span className="side-menu-bagde">{menu.bagdeNumber}</span>)}
                                        {elementLock}
                                    </Link>
                                )}
                            </Menu.Item>
                        )
                    );
                } else {
                    const { children, icon, name, background, route, isLicense } = menu;
                    let badgeNumber = 0;
                    _.forEach(children, (x) => (badgeNumber = badgeNumber + (x.bagdeNumber > 0 ? x.bagdeNumber : 0)));
                    return (
                        <Menu.SubMenu
                            key={route}
                            forceSubMenuRender
                            title={
                                <div className="route-side-menu ">
                                    {icon && (
                                        <div className="side-menu-icon-wrap">
                                            <i className={`${icon} ${background ? "side-menu-icon" : ""}`}
                                                style={{ background }} />
                                        </div>
                                    )}
                                    {`${menu.lvl > 1 ? index + 1 + ". " : ""}${t("AppMenu-" + this.generateMenuCode(name))}`}
                                    {badgeNumber > 0 && (badgeNumber > 100 ?
                                        <span className="badge-total">{"99+"}</span> :
                                        <span className="badge-total">{badgeNumber}</span>)}
                                </div>
                            }
                        >
                            {this.renderMenu(children, index + 1)}
                        </Menu.SubMenu>
                    );
                }
            }
        });
    }

    onOpenChange = (openKeys) => {
        AppStore.dispatch(onChangeOpenKeys(openKeys));
    };

    render() {
        return (
            <Menu
                mode="inline"
                theme="light"
                style={{
                    flex: 1,
                    marginTop: 15,
                }}
                className="side-menu"
                inlineIndent={18}
                // inlineCollapsed={this.props.collapsed}
                onOpenChange={this.onOpenChange}
                openKeys={this.props.openKeys}
                selectedKeys={this.props.selectKeys}
            >
                {this.renderMenu(this.props.sideMenu, 0)}
            </Menu>
        );
    }
}

function mapStateToProps(state) {
    const rootState = state.root;
    return {
        selectKeys: rootState.selectKeys,
        openKeys: rootState.openKeys,
        sideMenu: rootState.sideMenu,
        allMenuItems: rootState.allMenuItems,
    };
}

export default connect(mapStateToProps)(AppMenu);
